import React from 'react'
import processH5 from '../../../assets/process_h5.png'
import { toPage } from '../../utils'
// import { Mask } from 'antd-mobile'

const info = [
  {
    title: '入驻申请',
    subTitle: '登录后提交营业执照、法人/经营者身份证明、店铺LOGO等',
    time: '3～5分钟',
  },
  {
    title: '招商洽谈',
    subTitle: '招商经理1V1服务，洽谈合作细节，签订合同',
    time: '',
  },
  {
    title: '等待审核',
    subTitle:
      '等待商服人员审核资料，所需时间1～3个工作日，请注意接收短信通知。微信关注【遥望云链服务号】接收服务动态',
    time: '1～3个工作日',
  },
  {
    title: '缴纳费用',
    subTitle: '上传法人身份证、缴纳保证金，上传商品后即可进行直播报品',
    time: '',
  },
]

export default function Process(props: any) {
  const { setSelectedTab } = props
  const [showVideo, setShowVideo] = React.useState(false)
  return (
    <div className="process-wrapper">
      {showVideo ? (
        <video
          className="video-play"
          autoPlay
          controls
          muted
          src={
            'https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/supplier/temp/teach.mov'
          }
        />
      ) : (
        <img
          className="left-content"
          onClick={() => {
            setShowVideo(true)
          }}
          src={processH5}
          alt=""
        />
      )}

      <div className="right-content">
        <div className="item-wrapper">
          {info.map((item, index) => {
            const { title, subTitle, time } = item
            return (
              <div className="item" key={index}>
                <div className="number">0{index + 1}</div>
                <div className="content">
                  <div className="title-wrapper">
                    <div className="title">{title}</div>
                    {time && <div className="time">{time}</div>}
                  </div>
                  <div className="tips">{subTitle}</div>
                </div>
              </div>
            )
          })}
        </div>
        <div
          className="action-btn"
          onClick={() => {
            toPage('为了更好的入驻体验，请前往PC端完成入驻')
          }}
        >
          立即入驻
        </div>
        <div className="line"></div>
        <div
          className="more-info"
          onClick={() => {
            setSelectedTab(2)
          }}
        >
          查询入驻材料
        </div>
      </div>

      {/* <Mask
        visible={showVideo}
        onMaskClick={() => setShowVideo(false)}
        // className='mask-video'
      >
        <video
          style={{ width: '100%' }}
          autoPlay
          controls
          muted
          src={
            'https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/supplier/temp/teach.mov'
          }
        />
      </Mask> */}
    </div>
  )
}
